import React, { useState, useEffect } from "react"
import {
  CardBody,
  Container,
  Row,
  Col,
  Card,
  Button,
  TabPane,
  Form,
  Modal,
  Label,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useHistory } from "react-router-dom"
import { toast } from "react-toastify"
import logo from "../../assets/images/onesquar.png"
import { URLS } from "../../Url"
import axios from "axios"
import trash from "../../assets/images/trash.gif"
import Verify from "../../assets/images/mark1.gif"
import { saveAs } from "file-saver"
import { FaFilePdf } from "react-icons/fa"

function State() {
  const [forms, setforms] = useState([])

  const [modal_small, setmodal_small] = useState(false)

  function tog_small() {
    setmodal_small(!modal_small)
  }

  const [modal_small1, setmodal_small1] = useState(false)

  function tog_small1() {
    setmodal_small1(!modal_small1)
  }

  const [Doc, setDoc] = useState([])

  const history = useHistory()

  useEffect(() => {
    GetOneActins()
  }, [])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const Actinid = sessionStorage.getItem("VendorId")

  const GetOneActins = () => {
    const data = {
      userId: Actinid,
    }
    var token = datas
    axios
      .post(URLS.GetIdVendor, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        // setforms(res.data?.vendor[0])
        setforms(res.data?.vendor[0])
        setDoc(res.data?.vendor[0]?.kyc)
      })
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)

  const [form2, setform2] = useState([])

  const getpopup = data => {
    setform2(data)
    tog_small()
  }

  const handleSubmit1 = e => {
    e.preventDefault()
    Editstate()
  }

  const Editstate = () => {
    var token = datas

    const dataArray = {
      vendorId: form2._id,
      vendorStatus: "approved",
    }

    axios
      .put(URLS.VendorStatusUpadate, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            setmodal_small(false)
            history.push("/Vendor")
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const [form3, setform3] = useState([])

  const [form4, setform4] = useState([])

  const getpopup1 = data => {
    setform3(data)
    tog_small1()
  }

  const handleSubmit3 = e => {
    e.preventDefault()
    Editstate3()
  }

  const handleChange1 = e => {
    let myUser = { ...form4 }
    myUser[e.target.name] = e.target.value
    setform4(myUser)
  }

  const Editstate3 = () => {
    var token = datas

    const dataArray = {
      vendorId: form3._id,
      vendorStatus: "rejected",
      vendorRejectedReason: form4.vendorRejectedReason,
    }

    axios
      .put(URLS.VendorStatusRejected, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            setmodal_small(false)
            history.push("/RejectedVendors")
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const downloadImage = url => {
    saveAs(url, url.split("/").pop())
  }

  const handleDownload = url => {
    saveAs(url, url.split("/").pop())
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Home"
            breadcrumbItem="View Business Man Details"
          />
          <Row>
            <Col>
              <Button
                onClick={() => history.goBack()}
                className="mb-3  m-1 "
                style={{ float: "right" }}
                color="primary"
              >
                <i className="far fa-arrow-alt-circle-left"></i> Back
              </Button>
              {Roles?.PendingVendorListingApproved == true ||
              Roles?.accessAll == true ? (
                <>
                  {forms?.vendorStatus == "rejected" ? (
                    <></>
                  ) : (
                    <>
                      <Button
                        onClick={() => {
                          getpopup1(forms)
                        }}
                        className="mb-3  m-1 "
                        style={{ float: "right" }}
                        color="danger"
                      >
                        <div className="d-flex">
                          <i className="fas fa-user-lock px-1"></i>Reject
                        </div>
                      </Button>
                      <Button
                        onClick={() => {
                          getpopup(forms)
                        }}
                        className="mb-3  m-1 "
                        style={{ float: "right" }}
                        color="success"
                      >
                        <div className="d-flex">
                          <i className="bx bx-edit m-1"></i>
                          Verify
                        </div>
                      </Button>
                    </>
                  )}
                </>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Row className="mb-5">
            <Col md={12}>
              <Card>
                <CardBody>
                  <TabPane tabId="5">
                    <Row>
                      <Col lg={4}>
                        <h5 className="mb-4 text-primary">
                          Business Man Information :-
                        </h5>
                        <ul className="list-unstyled vstack gap-3 mb-0">
                          {forms?.profilePic == "" ? (
                            <>
                              <img src={logo} height="150px" width="50%"></img>
                            </>
                          ) : (
                            <>
                              <img
                                src={URLS.Base + forms?.profilePic}
                                height="150px"
                                width="50%"
                              ></img>
                            </>
                          )}
                          <li>
                            <div className="d-flex mt-3">
                              <i className="bx bx-user font-size-18 text-primary"></i>
                              <div className="ms-3">
                                <h6 className="mb-1 fw-semibold">Name:</h6>
                                <span className="text-muted">
                                  {forms?.name}
                                </span>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="d-flex  mt-3">
                              <i className="bx bx-message-rounded font-size-18 text-primary"></i>
                              <div className="ms-3">
                                <h6 className="mb-1 fw-semibold">Email :</h6>
                                {forms?.email}
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="d-flex  mt-3">
                              <i className="bx bx-phone font-size-18 text-primary"></i>
                              <div className="ms-3">
                                <h6 className="mb-1 fw-semibold">
                                  Contact Number:
                                </h6>
                                {forms?.phone}
                              </div>
                            </div>
                          </li>
                          <div className="d-flex mt-3">
                            <i className="bx bx-phone font-size-18 text-primary"></i>
                            <div className="ms-3">
                              <h6 className="mb-1 fw-semibold">Coins:</h6>
                              {forms?.coins || 0}
                            </div>
                          </div>

                          <li>
                            <div className="d-flex mt-3">
                              <i className="bx bx-area font-size-18 text-primary"></i>
                              <div className="ms-3">
                                <h6 className="mb-1 fw-semibold">
                                  Business Type:
                                </h6>
                                <span className="text-muted">
                                  {forms?.vendor == false ? (
                                    <>{"Business"}</>
                                  ) : (
                                    <>{"Business"}</>
                                  )}
                                </span>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="d-flex  mt-3">
                              <i className="bx bx-broadcast font-size-18 text-primary"></i>
                              <div className="ms-3">
                                <h6 className="mb-1 fw-semibold">Status :</h6>
                                <span className="badge bg-warning">
                                  {forms?.vendorStatus}
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </Col>
                      <Col lg={4}>
                        <ul className="verti-timeline list-unstyled ">
                          <h5 className="mb-4 text-primary">
                            Business Details :-
                          </h5>
                          <li className="event-list">
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle"></i>
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <div>
                                  {/* <h6 className="font-size-14 mb-1">Service</h6> */}
                                  <h6 className="font-size-14 mb-1">Category</h6>
                                  {/* <p className="text-muted">{forms?.service}</p> */}
                                  <p className="text-muted">{forms?.categoryName}</p>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li className="event-list">
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle"></i>
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <div>
                                  <h6 className="font-size-14 mb-1">
                                    Business Name
                                  </h6>
                                  <p className="text-muted">
                                    {forms?.businessName}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li className="event-list">
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle"></i>
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <div>
                                  <h6 className="font-size-14 mb-1">
                                    Business Phone
                                  </h6>
                                  <p className="text-muted">
                                    {forms?.businessPhone}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li className="event-list">
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle"></i>
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <div>
                                  <h6 className="font-size-14 mb-1">
                                    Business Email
                                  </h6>
                                  <p className="text-muted">
                                    {forms?.businessEmail}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li className="event-list">
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle"></i>
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <div>
                                  <h6 className="font-size-14 mb-1">
                                    GST Number
                                  </h6>
                                  <p className="text-muted">
                                    {forms?.GSTINnumber}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </li>

                          <li className="event-list">
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle"></i>
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <div>
                                  <h6 className="font-size-14 mb-1">Business Details</h6>
                                  <p className="text-muted">
                                    {forms?.description}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </li>

                          <li className="event-list">
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle"></i>
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <div>
                                  <h6 className="font-size-14 mb-1">About us</h6>
                                  <p className="text-muted">
                                    {forms?.aboutUs}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </li>

                          <li className="event-list">
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle"></i>
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <div>
                                  <h6 className="font-size-14 mb-1">Date of Established</h6>
                                  <p className="text-muted">
                                    {forms?.dateEstablished}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </li>

                          <li className="event-list">
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle"></i>
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <div>
                                  <h6 className="font-size-14 mb-1">Open Time</h6>
                                  <p className="text-muted">
                                    {forms?.openTime}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </li>

                          <li className="event-list">
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle"></i>
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <div>
                                  <h6 className="font-size-14 mb-1">Close Time</h6>
                                  <p className="text-muted">
                                    {forms?.closeTime}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </li>

                          <li className="event-list">
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle"></i>
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <div>
                                  <h6 className="font-size-14 mb-1">Website</h6>
                                  <p className="text-muted">
                                    {forms?.businessWebsite}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </li>

                          <li className="event-list">
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle"></i>
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <div>
                                  <h6 className="font-size-14 mb-1">
                                    Business Logo
                                  </h6>
                                  <div className="d-flex align-items-center">
                                    <img
                                      src={URLS.Base + forms?.businessLogo}
                                      style={{
                                        width: "100px",
                                        cursor: "pointer",
                                      }}
                                      alt="businessLogo"
                                    />
                                    <i
                                      className="bx bx-download"
                                      style={{
                                        fontSize: "24px",
                                        color: "#007bff",
                                        marginLeft: "10px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        downloadImage(
                                          URLS.Base + forms?.businessLogo
                                        )
                                      }
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </Col>
                      <Col lg={4}>
                        <ul className="verti-timeline list-unstyled ">
                          <h5 className="mb-4 text-primary">
                            Address Details :-
                          </h5>
                          <li className="event-list ">
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle"></i>
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <div>
                                  <h6 className="font-size-14 mb-1">Address</h6>
                                  <p className="text-muted">
                                    {forms?.businessAddress}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li className="event-list">
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle"></i>
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <div>
                                  <h6 className="font-size-14 mb-1">
                                    Lattitude / Longitude
                                  </h6>
                                  <p className="text-muted">
                                    {forms?.businessLatitude} /
                                    {forms?.businessLongitude}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li className="event-list">
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle"></i>
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <div>
                                  <h6 className="font-size-14 mb-1">
                                    Pin Code
                                  </h6>
                                  <p className="text-muted">
                                    {forms?.businessPincode}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </Col>
                    </Row>
                    {/* <Row>
                      <h5 className="mt-4 text-primary">
                        Business Man Documents :-
                      </h5>
                      {Doc?.map((data, key) => (
                        <Col md="3" key={key} className="mt-5">
                          <div
                            key={key}
                            className="d-inline-flex align-items-center mb-2"
                          >
                      
                            {data.endsWith(".jpg") ||
                            data.endsWith(".png") ||
                            data.endsWith(".jpeg") ? (
                              <>
                                <img
                                  src={URLS.Base + data}
                                  style={{
                                    width: "100px",
                                    cursor: "pointer",
                                  }}
                                  alt={`Document ${key}`}
                                  onClick={() =>
                                    downloadImage(URLS.Base + data)
                                  }
                                />
                                <i
                                  className="bx bx-download"
                                  style={{
                                    fontSize: "24px",
                                    color: "#007bff",
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    downloadImage(URLS.Base + data)
                                  }
                                ></i>
                              </>
                            ) : data.endsWith(".pdf") ? (
                              <>
                                <FaFilePdf
                                  style={{
                                    fontSize: "24px",
                                    color: "#e03e36",
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDownload(URLS.Base + data)
                                  }
                                />
                                <span
                                  style={{
                                    marginLeft: "10px",
                                    fontSize: "16px",
                                  }}
                                >
                                  Download PDF
                                </span>
                              </>
                            ) : null}
                          </div>
                        </Col>
                      ))}
                    </Row> */}
                    
                    <Row>
                      {/* Conditionally render heading based on the first document type */}
                      <h5 className="mt-4 text-primary">
                        {Doc?.[0]?.endsWith(".jpg") ||
                        Doc?.[0]?.endsWith(".png") ||
                        Doc?.[0]?.endsWith(".jpeg")
                          ? "Business Images :-"
                          : Doc?.[0]?.endsWith(".pdf")
                          ? "Business Man Documents :-"
                          : "Business Man Documents :-"}
                      </h5>

                      {Doc?.map((data, key) => (
                        <Col md="3" key={key} className="mt-5">
                          <div className="d-inline-flex align-items-center mb-2">
                            {/* Check if the data is an image or a PDF */}
                            {data.endsWith(".jpg") ||
                            data.endsWith(".png") ||
                            data.endsWith(".jpeg") ? (
                              <>
                                <img
                                  src={URLS.Base + data}
                                  style={{
                                    width: "100px",
                                    cursor: "pointer",
                                  }}
                                  alt={`Document ${key}`}
                                  onClick={() =>
                                    downloadImage(URLS.Base + data)
                                  }
                                />
                                <i
                                  className="bx bx-download"
                                  style={{
                                    fontSize: "24px",
                                    color: "#007bff",
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    downloadImage(URLS.Base + data)
                                  }
                                ></i>
                              </>
                            ) : data.endsWith(".pdf") ? (
                              <>
                                <FaFilePdf
                                  style={{
                                    fontSize: "24px",
                                    color: "#e03e36", // Colorful PDF icon
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDownload(URLS.Base + data)
                                  }
                                />
                                <span
                                  style={{
                                    marginLeft: "10px",
                                    fontSize: "16px",
                                  }}
                                >
                                  Download PDF
                                </span>
                              </>
                            ) : null}
                          </div>
                        </Col>
                      ))}
                    </Row>
                    
                  </TabPane>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal
          size="md"
          isOpen={modal_small}
          toggle={() => {
            tog_small()
          }}
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="mySmallModalLabel">
              Verify Business Man
            </h5>
            <button
              onClick={() => {
                setmodal_small(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form
              onSubmit={e => {
                handleSubmit1(e)
              }}
            >
              <img src={Verify} width="100%" height="400px"></img>

              <div style={{ float: "right" }} className="mt-3">
                <Button
                  onClick={() => {
                    setmodal_small(false)
                  }}
                  color="danger"
                  type="button"
                >
                  Cancel <i className="fas fa-times-circle"></i>
                </Button>
                <Button className="m-1" color="primary" type="submit">
                  Submit <i className="fas fa-check-circle"></i>
                </Button>
              </div>
            </Form>
          </div>
        </Modal>
        <Modal
          size="md"
          isOpen={modal_small1}
          toggle={() => {
            tog_small1()
          }}
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="mySmallModalLabel">
              Reject Business Man
            </h5>
            <button
              onClick={() => {
                setmodal_small1(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form
              onSubmit={e => {
                handleSubmit3(e)
              }}
            >
              <img src={trash} width="100%" height="300px"></img>

              <Col md={12}>
                <div className="mb-3">
                  <Label for="basicpill-firstname-input3">
                    Reason <span className="text-danger">*</span>
                  </Label>{" "}
                  <textarea
                    type="text"
                    rows="3"
                    className="form-control "
                    id="basicpill-firstname-input1"
                    placeholder="Enter Reject Reason"
                    required
                    value={form4.vendorRejectedReason}
                    name="vendorRejectedReason"
                    onChange={e => {
                      handleChange1(e)
                    }}
                  />
                </div>
              </Col>
              <div style={{ float: "right" }}>
                <Button
                  onClick={() => {
                    setmodal_small1(false)
                  }}
                  color="danger"
                  type="button"
                >
                  Cancel <i className="fas fa-times-circle"></i>
                </Button>
                <Button className="m-1" color="primary" type="submit">
                  Submit <i className="fas fa-check-circle"></i>
                </Button>
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default State
